import type { ReactNode } from 'react';

export const symbol_shield_with_house: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-592 236-402q22 72 67.5 130.5T410-176v-144q0-12.75 8.63-21.38Q427.25-350 440-350h80q12.75 0 21.38 8.62Q550-332.75 550-320v144q61-37 106.5-95.5T724-402L480-592ZM220-719v196q0 12.65 1 27.82 1 15.18 3 28.18l256-200 256 200q2-13 3-28.18 1-15.17 1-27.82v-196l-260-98-260 98ZM470.12-85q-4.56-1-9.12-3-139-47-220-168.5t-81-266.61V-719q0-19.26 10.88-34.66Q181.75-769.07 199-776l260-97q11-4 21-4t21 4l260 97q17.25 6.93 28.13 22.34Q800-738.26 800-719v195.89Q800-378 719-256.5T499-88q-4.56 2-9.12 3T480-84q-5.32 0-9.88-1Z"
		/>
	</svg>
);
